export enum Steps {
    SELECT_PLAN,
    PAYMENT,
    THANK_YOU
}

export interface LeadsPlan { 
	id: number,
    service_id: number,
    title: string,
    label?: string,
    price: number,
    price_per_lead: number,
    leads_amount: number
}

export interface Plans { 
	[key: string]: LeadsPlan
}

export interface LeadsState { 
    leadsPlans: Plans,
    step: Steps,
    uuid: string,
	selectedPlanId: number
}

export const getInitialLeadsState = (): LeadsState => ({
	leadsPlans: {},
	selectedPlanId: 0,
	step: Steps.SELECT_PLAN,
	uuid: '' 
})
